import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';

const route = new StepRoute(
  RouteNames.AppointmentCreateAccount,
  'create-account',
  () => import('@/views/steps/CreateAccountStep.vue'),
);

route.isAccountManagementStep();
route.requiresScheduleStep();
route.requiresPropertyStep();
route.showSummarySidebar();

export default route.getRoute();
